import Vue from 'vue'
Vue.prototype.$translation = {
  'es': {
    'identity': {
      'appName': 'Registros',
      'slogan': '',
      'welcome': 'Publica tus anuncios en solo una hora y capta la atención de tu audiencia de manera efectiva. ¡Es rápido, fácil y sin complicaciones! 🎉',
    },
    'button': {
      'access': 'INGRESAR',
      'continue': 'CONTINUAR',
      'next': 'Siguiente',
      'prev': 'Anterior',
      'close': 'Cerrar',
      'change': 'Cambiar',
      'forgettPassword': '¿Olvidaste tu contraseña?',
      'mySite': 'MI SITIO',
      'myProjects': 'MIS PROYECTOS',
      'editAuthor': 'EDITAR AUTOR',
      'changePassword': 'CAMBIAR CONTRASEÑA',
      'help': 'AYUDA',
      'logout': 'CERRAR SESSIÓN',
      'rename': 'RENOMBRAR',
      'toCloud': 'MOVER A LA NUBE',
      'toOnline': 'COMPARTIR ONLINE',
      'public': 'PUBLICO',
      'toOffline': 'DEJAR DE COMPARTIR',
      'toTop': 'COLOCAR PRIMERO',
      'save': 'GUARDAR',
      'private': 'PRIVADO',
      'recover': 'RECUPERAR',
      'delete': 'ELIMINAR',
      'toTrash': 'MOVER A PAPELERA',
      'edit': 'Modificar',
      'update': 'Actualizar',
      'notSave': ' No guardar',
      'createProject': ' Crear proyecto',
      'editProject': 'MODIFICAR PROYECTO',
      '': '',
    },
    'input': {
      'search': 'Buscar coincidencias..',
      'name': 'Nombre',
      'lastname': 'Apellido',
      'email': 'Correo electrónico',
      'password': 'Contraseña',
      'country': 'Pais',
      'occupation': 'Ocupación',
      'repeatPassword': 'Repetir contraseña',
      'enterText': 'Ingresar texto',
      'titleProject': 'Título del proyecto',
      'summaryproject': 'Resumen del proyecto',
      'day': 'Dia',
      'month': 'Mes',
      'year': 'Año',

    },
    'label': {
      'signIn': 'CREAR CUENTA',
      'login': 'INICIAR SESIÓN',
      'logout': 'CERRAR SESSIÓN',
      'editAuthor': 'EDITAR AUTOR',
      'changePassword': 'CAMBIAR CONTRASEÑA',
      'confirmPassword': 'CONFIRMAR CONTRASEÑA',
      'newPassword': 'Nueva contraseña',
      'repeatNewPassword': 'Repetir nueva contraseña',
      'todayPassword': 'Actual contraseña',
      'dateBirth': 'Fecha de Nacimiento',
      'loading': 'Cargando',
      'myProjects': 'MIS PROYECTOS',
      'home': 'EN CASA',
      'cloud': 'NUBE',
      'trash': 'PAPELERA',
      'tips': 'CONSEJOS',
      'inTrash': 'EN PAPELERA',
      'cleanTrash': 'LIMPIAR',
      'renameTitle': 'RENOMBRAR TÍTULO',
      'createProject': 'CREAR PROYECTO',
      'new': 'NUEVO',
      'editProject': 'MODIFICAR PROYECTO',
      'addPage': 'AGREGAR UN PÁGINA',
      'showMore': 'Ver mas'
    },
    'sms': {
      'empty': 'Verifique su información y vuelva a intentar',
      'registed': 'Cuenta creada con exito.',
      'exists': 'El correo ya fue registrado.',
      'pair': 'Las contraseñas no coinciden.',
      'incorrectCredentials': 'Correo o contraseña incorrecta',
      'validate': 'revise su correo electronico para validar su cuenta ',
      'error': 'Lo sentimos, vuelva a intentar',
    },
    'movilMenu': {
      'topics': 'MIS TEMAS',
      'online': 'EN LINEA',
      'search': 'BUSCAR',
    },
    'createAuthor': {
      'regionless': 'Sin región',
    },
    'createProject': {
      'emptyTitle': 'Sin título',
      'enterText': 'Ingresar texto',
      'emptySummary': 'Sin resumen',
    },
    'typeProject': {
      'book': 'Libro',
      'education': 'Educación',
      'music': 'Musica',
      'diary': 'Diario',
      'healt': 'Salud',
      'travel': 'Viajes',
      'sport': 'Deportes',
      'science': 'Ciencia',
      'cinema': 'Cine',
      'humor': 'Humor',
    },
    'typeProjectSummary': {
      'book': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla enim elit, finibus id gravida eu, scelerisque sit amet risus. Curabitur vitae eros et leo convallis lacinia et eu ipsum. Aliquam quis quam a nibh lacinia tincidunt.',
      'education': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla enim elit, finibus id gravida eu, scelerisque sit amet risus. Curabitur vitae eros et leo convallis lacinia et eu ipsum. Aliquam quis quam a nibh lacinia tincidunt.',
      'music': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla enim elit, finibus id gravida eu, scelerisque sit amet risus. Curabitur vitae eros et leo convallis lacinia et eu ipsum. Aliquam quis quam a nibh lacinia tincidunt.',
      'diary': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla enim elit, finibus id gravida eu, scelerisque sit amet risus. Curabitur vitae eros et leo convallis lacinia et eu ipsum. Aliquam quis quam a nibh lacinia tincidunt.',
      'healt': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla enim elit, finibus id gravida eu, scelerisque sit amet risus. Curabitur vitae eros et leo convallis lacinia et eu ipsum. Aliquam quis quam a nibh lacinia tincidunt.',
      'travel': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla enim elit, finibus id gravida eu, scelerisque sit amet risus. Curabitur vitae eros et leo convallis lacinia et eu ipsum. Aliquam quis quam a nibh lacinia tincidunt.',
      'sport': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla enim elit, finibus id gravida eu, scelerisque sit amet risus. Curabitur vitae eros et leo convallis lacinia et eu ipsum. Aliquam quis quam a nibh lacinia tincidunt.',
      'science': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla enim elit, finibus id gravida eu, scelerisque sit amet risus. Curabitur vitae eros et leo convallis lacinia et eu ipsum. Aliquam quis quam a nibh lacinia tincidunt.',
      'cinema': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla enim elit, finibus id gravida eu, scelerisque sit amet risus. Curabitur vitae eros et leo convallis lacinia et eu ipsum. Aliquam quis quam a nibh lacinia tincidunt.',
      'humor': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla enim elit, finibus id gravida eu, scelerisque sit amet risus. Curabitur vitae eros et leo convallis lacinia et eu ipsum. Aliquam quis quam a nibh lacinia tincidunt.',
    },
    'post': {
      'activity': 'Actividad',
      'posts': 'Publicaciones',
      'like': 'Me gusta',
      'visits': 'Visitas',
      'author': 'Autor',
      'continue': 'Continuar Lectura',
      'page': 'Página',
      'comments': 'Comentarios',
      'writeComment':'Escribe un comentario',
      'endComments':'Fin de comentarios'
    },
    'months': {
      'january': 'Enero',
      'february': 'Febrero',
      'march': 'Marzo',
      'april': 'Abril',
      'may': 'Mayo',
      'june': 'Junio',
      'july': 'Julio',
      'august': 'Agosto',
      'september': 'Septiembre',
      'october': 'Octubre',
      'november': 'Noviembre',
      'december': 'Diciembre',
    },
    'tips': [
      'Comparte con el mundo tus temas',
      'Busca letras inspiradoras',
      'Crea la letra para tus canciones',
      'Inicia un libro, añade temas de interes',
      'Rompe todos los esquemas de tu ritmo, se unico y natural, inspirate y crea nuevas ideas']
  },
  'en': {

    'identity': {
      'appName': 'Registros',
      'slogan': 'Quick Ads - Stand Out Instantly.',
      'welcome': 'Publish your ads in just one hour and grab your audience’s attention quickly and effortlessly. It’s fast, easy, and hassle-free! 🎉.'
    },
    'button': {
      'access': 'SIGN IN',
      'continue': 'CONTINUE',
      'next': 'NEXT',
      'forgettPassword': 'Forgot your password?',
      'rename': 'RENAME',
      'toCloud': 'MOVE TO CLOUD',
      'toOnline': 'SHARE ONLINE',
      'public': 'PUBLIC',
      'toOffline': 'STOP SHARING',
      'private': 'PRIVATE',
      'recover': 'RECOVER',
      'delete': 'DELETE',
      'toTrash': 'MOVE TO TRASH',
      'edit': 'EDIT',
      'save': 'SAVE',
      'notSave': ' Not save',
      'createProject': ' Create project'
    },
    'input': {
      'search': 'Search for matches..',
      'email': 'Email',
      'password': 'password',
      'newPassword': 'New password',
      'repeatPassword': 'Repeat password',
      'enterText': 'Enter Text',
      'titleProject': 'Title project',
      'summaryproject': 'Summary project',
    },
    'label': {
      'signIn': 'CREATE ACCOUNT',
      'login': 'SIGN IN',
      'projects': 'projecTS',
      'home': 'HOME',
      'cloud': 'CLOUD',
      'trash': 'TRASH',
      'tips': 'TIPS',
      'inTrash': 'IN TRASH',
      'renameTitle': 'RENAME TITLE',
      'createProject': 'CREATE projecT',
      'addPage': 'ADD PAGE'
    },
    'movilMenu': {
      'topics': 'MY TOPICS',
      'online': 'ONLINE',
      'search': 'SEARCH'
    },
    'createProject': {
      "emptyTitle": "Untitled",
      "emptyText": "No text"
    },
    'onlineCard': {
      'like': 'Like',
      'visits': 'Visits',
      'author': 'Author'
    },
    'tips': [
      'Comparte con el mundo tus temas',
      'Busca letras inspiradoras',
      'Crea la letra para tus canciones',
      'Inicia un libro, añade temas de interes',
      'Rompe todos los esquemas de tu ritmo, se unico y natural, inspirate y crea nuevas ideas']
  }
}
